import Routes from "routing/Routes";
class NotificationsFactory {
  static getValuesForNotification(notification) {
    switch (notification.type) {
      case "legacy_ldap_config_migration": {
        const { auth_service_id: authServiceId } = notification.details;
        return {
          values: {
            AUTHENTICATION_BACKEND: Routes.SYSTEM.AUTHENTICATION.BACKENDS.show(authServiceId.toString())
          }
        };
      }
      case "no_input_running":
      case "input_failure_shutdown":
      case "input_failed_to_start": {
        return {
          values: {
            SYSTEM_INPUTS: Routes.SYSTEM.INPUTS
          }
        };
      }
      case "data_node_needs_provisioning":
        return {
          values: {
            DATA_NODE_CONFIGURATION: Routes.SYSTEM.CLUSTER.CERTIFICATE_MANAGEMENT
          }
        };
      case "remote_reindex_running":
      case "remote_reindex_finished":
        return {
          values: {
            DATA_NODE_MIGRATION_WIZARD: Routes.SYSTEM.CLUSTER.DATANODE_MIGRATION
          }
        };
      default:
        return void 0;
    }
  }
}
export default NotificationsFactory;
